enum AgeGroup {
    INFANT = 'infant',
    CHILD = 'child',
    ADULT = 'adult',
    SENIOR = 'senior',
}

export default AgeGroup